export default {
  bmId: {
    id: 'bo_sellers-listing-search-product-card-bmid',
    defaultMessage: 'Back MarketID: {bmId}',
  },
  productId: {
    id: 'bo_sellers-listing-search-product-card-product-id',
    defaultMessage: 'Product ID: {productId}',
  },
  actionSellItem: {
    id: 'bo_sellers-listing-search-product-card-actions-sell-item',
    defaultMessage: 'Sell item',
  },
  actionSellSimilarVersion: {
    id: 'bo_sellers-listing-search-product-card-actions-sell-similar-version',
    defaultMessage: 'Sell similar version of item',
  },
  actionShowDetails: {
    id: 'bo_sellers-listing-search-product-card-actions-show-details',
    defaultMessage: 'Details',
  },
  simType: {
    id: 'bo_seller-listing-search-product-card-sim-type',
    defaultMessage: 'SIM: {simType, html}',
  },
}
